<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Special thanks to Robert Mazza of Mazza Vineyards in North East, Pennsylvania, for supplying photographs of the South Shore Wine Company, and Douglas P. Moorhead of Presque Isle Wine Cellars in North East for background information on the passage of the Limited Winery Act. Both of them were kind enough to take the time to review the manuscript before publication. Any errors in this book, however, are strictly ours.</p>
<p class="indent">We have known virtually all of the people who have made the modern Pennsylvania grape and wine industry what it is today. In one way or another, what we have written in this book is about all of them, and we acknowledge our debt to the entire Pennsylvania grape and wine industry. It has been a privilege to work with you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?32e01481